import React from 'react';

function FeedbackYieldIcon() {
  return (
    <svg width={24} height={18} fill="none">
      <title>Ilustração de rendimento</title>
      <path
        d="M23.737 3.401l-.594.754-2.023-1.594V23.04h-.96V2.56l-2.023 1.595-.594-.754L20.64.96l3.097 2.441zM13.44 9.6h-.96v13.44h.96V9.6zM16.32 5.76h.96v17.28h-.96V5.76zM9.6 13.44h-.96v9.6h.96v-9.6zM4.8 17.28h.96v5.76H4.8v-5.76zM1.92 21.12H.96v1.92h.96v-1.92z"
        fill="#111"
      />
    </svg>
  );
}

export default FeedbackYieldIcon;
